<script>
export default {
  props: {
    value: [String, Number, Array],
    mapId: {
      type: String,
      default: "id",
    },
  },
  i18n: {
    messages: {
      en: { 'remote-placeholder': 'Please enter id search'},
      zh: { 'remote-placeholder': '请输入ID进行搜索'}
    }
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.remoteMethod("");
  },
  methods: {
    remoteMethod(query) {
      this.ccRequest
        .do("admin/fsb/product/query", { jobId: query, pageSize: 20 }, "GET")
        .then((res) => {
          const { rows } = res;
          this.options = rows.map((item) => ({
            label: item.jobId,
            value: item[this.mapId],
            customer: item.customer && item.customer.customerName,
          }));
        });
    },
    updateValue(val) {
      this.$emit("input", val);
    },
  },
  render(h) {
    const options = this.options.map((option) =>
      h("el-option", {
        props: {
          label: `${option.customer} ${option.label}`,
          value: option.value,
        },
      })
    );
    return h(
      "el-select",
      {
        props: {
          clearable: true,
          filterable: true,
          remote: true,
          value: this.value,
          "remote-method": this.remoteMethod,
          placeholder: this.$t('remote-placeholder'),
          ...this.$attrs,
        },
        on: {
          input: this.updateValue,
        },
      },
      options
    );
  },
};
</script>
